<template>
  <b-navbar toggleable="md" type="dark" class="sub-navbar">
    <b-container>
      <div class="sub-nav-container">
        <b-collapse id="sub_nav_collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item
              v-for="(item, idx) in subNav"
              v-if="!$root.isDemo() || item.demo"
              :key="item.title"
              :to="item.link"
              :exact="idx === 0"
              :class="{ disabled : isDisabled(item) }"
              class="text-center"
              @click="onCloseSubnavClick"
            >
              <i :class="item.icon" class="ti ti-fw ti-2x" /><br>
              <span>{{ $t(item.title) }}</span>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-container>
  </b-navbar>
</template>

<script>
  export default {
    name: 'SubNavComponent',
    data() {
      return {
        id: null,
        subNav: [{
          link: null,
          linkInfo: {
            name: 'memorial.show',
          },
          icon: 'ti-user-circle',
          title: 'submenu.profile',
          demo: true,
        }, {
          link: null,
          linkInfo: {
            name: 'photo.index',
          },
          icon: 'ti-pictures',
          title: 'submenu.photos',
          demo: true,
        }, {
          link: null,
          linkInfo: {
            name: 'video.index',
          },
          icon: 'ti-picture',
          title: 'submenu.videos',
          demo: true,
        }, {
          link: null,
          linkInfo: {
            name: 'book.index',
          },
          icon: 'ti-docs',
          title: 'submenu.book',
          demo: true,
        }, {
          link: null,
          linkInfo: {
            name: 'candle.index',
          },
          icon: 'ti-envelope',
          title: 'submenu.candles',
          demo: true,
        }, {
          link: null,
          linkInfo: {
            name: 'subscription.index',
          },
          icon: 'ti-wallet',
          title: 'submenu.subscription',
          demo: false,
        }],
      };
    },
    watch: {
      '$store.state.oauth.user': {
        deep: true,
        handler(newUser) {
          let id = null;
          if (newUser && newUser.memorial) {
            ({ id } = newUser.memorial);
          }

          if (id !== null) {
            this.initLinks(id);
          }
        },
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
          this.loadNavigator(this.id);
        } else if (this.user() && this.user().memorial) {
          this.loadNavigator(this.user().memorial.id);
        }
      });
    },
    updated() {
      const { id } = this.$route.params;
      if (id && this.id !== id) {
        this.id = id;
        this.loadNavigator(this.id);
      }
    },
    methods: {
      onCloseSubnavClick() {
        if (this.$children[1]) {
          this.$set(this.$children[1], 'show', false);
        }
      },
      initLinks(id) {
        this.subNav.forEach((obj) => {
          this.$set(obj, 'link', { name: obj.linkInfo.name, params: { id } });
        });
      },
      isDisabled(item) {
        return item.disabled ? true : this.oauth() && this.user().memorial === undefined;
      },
      loadNavigator(id) {
        this.$bus.$on('t-event.click-on-parameters', () => {
          const newId = this.user().memorial.id;
          this.initLinks(newId);
        });

        if (this.$route.name === 'parameter') {
          const newId = this.user().memorial.id;
          this.initLinks(newId);
        }

        // eslint-disable-next-line no-extra-boolean-cast
        if (!!id) {
          this.initLinks(id);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .sub-navbar {
    background-color: $primary !important;
    position: fixed;
    left: 0;
    right: 0;
    z-index: 1000;

    .sub-nav-container {
      width: 100%;
    }

    ul.navbar-nav {
      width: 100%;
      justify-content: space-between;

      li {
        flex-basis: 120px;

        &.disabled {
          a {
            pointer-events: none;
            cursor: default;
            opacity: 0.6;
          }
        }

        a.nav-link {
          color: $white ;
          font-size: 14px;
          border-bottom: 2px solid transparent;

          &:hover,
          &.active {
            color: $white;
            border-bottom: 2px solid $white;
          }

          i {
            margin-bottom: 5px;
          }
        }
      }
    }
  }

  @include editable-max-width(767px) {
    .sub-navbar {
      padding: 0;

      ul.navbar-nav {
        margin-top: 10px;

        li {
          flex-basis: auto;
          margin-bottom: 10px;

          a.nav-link {
            display: flex;
            align-items: center;

            i {
              margin-bottom: 0;
            }

            span {
              font-size: 1rem;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SubNav.vue